import { openWarningAlertOnError } from 'model/alert';

import { getUser } from 'model/user';
import BonusRoute from './Bonus';
import OrderRoute from './Order';
import CouponRoute from './Coupon';

export default store => ({
	path: 'user',
	indexRoute: {
		component: null,
	},
	onEnter: (_, __, callback) => {
		const {
			auth: { accessToken },
		} = store.getState();

		if (accessToken === '') {
			store.dispatch(openWarningAlertOnError('請先登入'));
		} else {
			store.dispatch(getUser());
		}
		callback();
	},
	childRoutes: [BonusRoute(store), OrderRoute(store), CouponRoute(store)],
});
